import { render, staticRenderFns } from "./EmailRecipientList.vue?vue&type=template&id=91e737b2&"
import script from "./EmailRecipientList.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientList.vue?vue&type=script&lang=js&"
import style0 from "./EmailRecipientList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports